import type { FaireProductEntity } from "../../entity_types/product";

export const p_u5pcwnfwfq: FaireProductEntity = {
  token: "p_u5pcwnfwfq",
  type: "product",
  name: "Organic Cotton Classic Crew Socks",
  brandToken: "b_dtik0xdswq",
  brandName: "Maggie's Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/cb484b95095df7f9f5f14b465275adbce3a8a31db30db0f5ac8b317ebef0e801.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fb97dab4b5407b0419d9d10ceeb6ce308627d158a2bac440a4a13daa848109e4.png",
    "https://cdn.faire.com/fastly/a61e5864aa1137fd36efc44641020eaef5f294fdc0f42c0a9be11fb4936a4bab.jpeg",
    "https://cdn.faire.com/fastly/e40360d56de72eacb66e81674c1dbdba3ebd63e3eb8434a551f8a83259d5b98c.jpeg",
    "https://cdn.faire.com/fastly/798b593c80f3ce02ad7aa3f2582a939ef6ef68bef89059b4e41a5ff762c28632.jpeg",
    "https://cdn.faire.com/fastly/9552e942094bc7ffd4e16368baf420c0233159a0b21773397fbbbaa3c3de6148.jpeg",
    "https://cdn.faire.com/fastly/b1cece3968482dd884568481d6e145ca1792efbb9443f550f6c0cf32c26850ea.jpeg",
    "https://cdn.faire.com/fastly/c72ded70680239751c0dcfaaeb74a009184b6045d934b887b054b34c58603418.jpeg",
    "https://cdn.faire.com/fastly/d2ba9dc27590fef0fb02fa1944553b68a9c038bdd9230ca11279aae87edf4ce7.jpeg",
    "https://cdn.faire.com/fastly/1d3a86db0368d88cc8a530ef42cff231f2e68ef07cde51f2f5933e2a0a2b26f3.jpeg",
  ],
  priceDollars: 6,
  description:
    "Our best-selling mid-calf organic cotton crew socks. Perfect for both men and women, for dress or casual. Comfortable, durable. Year-round mid-weight.",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:26.276Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
